import { render, staticRenderFns } from "./WeldingSetting.vue?vue&type=template&id=4851fa02&scoped=true"
import script from "./WeldingSetting.vue?vue&type=script&lang=js"
export * from "./WeldingSetting.vue?vue&type=script&lang=js"
import style0 from "./WeldingSetting.vue?vue&type=style&index=0&id=4851fa02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851fa02",
  null
  
)

export default component.exports